import * as actions from '../actionTypes'

const initialState = {
  drivingSchoolInformation: {
    drivingSchoolName: '',
    contactName: '',
    phoneNumber: '',
  },
}

const DrivingSchoolInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.DRIVING_SCHOOL_NAME: {
      return {
        ...state,
        drivingSchoolInformation: {
          ...state.drivingSchoolInformation,
          drivingSchoolName: action.payload.description,
        },
      }
    }
    case actions.CONTACT_NAME: {
      return {
        ...state,
        drivingSchoolInformation: {
          ...state.drivingSchoolInformation,
          contactName: action.payload.description,
        },
      }
    }
    case actions.DRIVING_SCHOOL_PHONE_NUMBER: {
      return {
        ...state,
        drivingSchoolInformation: {
          ...state.drivingSchoolInformation,
          phoneNumber: action.payload.description,
        },
      }
    }
    case actions.CLEAR_ALL_FIELDS: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default DrivingSchoolInformationReducer
